export const DEFAULT_CUSTOMER_TAB = "1";
export const CUSTOMER_LOCATIONS_TAB = "2";
export const CUSTOMER_BILLING_TAB = "3";
export const CUSTOMER_CONTACTS_TAB = "4";
export const CUSTOMER_TAX_TAB = "9";
export const CUSTOMER_UPGRADES_TAB = "10";

const CUSTOMER_TAB_IDS = new Set([
	"1",
	CUSTOMER_LOCATIONS_TAB,
	CUSTOMER_BILLING_TAB,
	"4",
	"5",
	"6",
	"7",
	"8",
	CUSTOMER_TAX_TAB,
	CUSTOMER_UPGRADES_TAB
]);

const resolveCustomerTab = (tab?: string): string => (tab && CUSTOMER_TAB_IDS.has(tab) ? tab : DEFAULT_CUSTOMER_TAB);

export default resolveCustomerTab;
